(function() {
  var stickySelectSelector = '.zrx-sticky-atc-bar .zrx-sticky-atc-select';
  var syncingVariantPickers = false;
  var syncFrame = null;
  var layoutStateFrame = null;
  var productDataCache = null;
  var cookieBannerObserverStarted = false;

  function applyCookieBannerClickFix() {
    var styleId = 'sks-cookie-banner-layer-fix';
    var consentButtonSelector = [
      '#shopify-pc__banner__btn-accept',
      '#shopify-pc__banner__btn-decline',
      '.shopify-pc__banner__btn-accept',
      '.shopify-pc__banner__btn-decline'
    ].join(',');

    if (!document.getElementById(styleId) && document.head) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '#shopify-pc__banner,',
        '#shopify-pc__banner__wrapper,',
        '#shopify-pc__banner__dialog,',
        '.shopify-pc__banner,',
        '.shopify-pc__banner__wrapper,',
        '.shopify-pc__banner__dialog{',
        'z-index:2147483000!important;',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    document.querySelectorAll(consentButtonSelector).forEach(function(button) {
      if (button.getAttribute('data-sks-cookie-safe-click') === 'true') {
        return;
      }

      button.setAttribute('data-sks-cookie-safe-click', 'true');
      button.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    });
  }

  function observeCookieBannerClickFix() {
    if (cookieBannerObserverStarted || typeof MutationObserver === 'undefined') return;
    cookieBannerObserverStarted = true;

    new MutationObserver(applyCookieBannerClickFix).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function escapeCssIdentifier(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getInputLabel(input) {
    if (!input) return '';

    var label = input.id ? document.querySelector('label[for="' + escapeCssIdentifier(input.id) + '"]') : null;
    if (!label && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      label = input.nextElementSibling;
    }

    return label ? label.textContent.replace(/\s+/g, ' ').trim() : input.value;
  }

  function getStickyOptionMap() {
    var optionMap = {};

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      Array.prototype.forEach.call(select.options || [], function(option) {
        optionMap[normalizeOptionText(option.text)] = true;
        optionMap[normalizeOptionText(option.value)] = true;
      });
    });

    return optionMap;
  }

  function getMainSizeInputs() {
    var fieldsets = Array.prototype.slice.call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset'));
    var sizeFieldset = fieldsets.find(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      return /taglia|taglie|size|misura|numero/i.test(legend ? legend.textContent : '');
    });

    if (sizeFieldset) {
      return Array.prototype.slice.call(sizeFieldset.querySelectorAll('input[data-option-position]'));
    }

    var stickyOptions = getStickyOptionMap();
    var inputGroups = {};

    document.querySelectorAll('variant-picker input[data-option-position], .variant-picker input[data-option-position]').forEach(function(input) {
      if (input.closest('.zrx-sticky-atc-bar')) return;

      var groupName = input.name || input.getAttribute('data-option-position') || 'default';
      inputGroups[groupName] = inputGroups[groupName] || [];
      inputGroups[groupName].push(input);
    });

    var groups = Object.keys(inputGroups).map(function(key) {
      return inputGroups[key];
    });

    if (groups.length === 1) return groups[0];

    return groups.find(function(group) {
      return group.some(function(input) {
        return stickyOptions[normalizeOptionText(getInputLabel(input))];
      });
    }) || [];
  }

  function getMainSelectedSize() {
    var selectedInput = getMainSizeInputs().find(function(input) {
      return input.checked;
    });

    if (selectedInput) return getInputLabel(selectedInput);

    var variantScript = document.querySelector('variant-picker script[data-variant]');
    if (!variantScript) return '';

    try {
      var variant = JSON.parse(variantScript.textContent || '{}');
      return variant.option1 || variant.public_title || variant.title || '';
    } catch (error) {
      return '';
    }
  }

  function setStickySelect(size, shouldDispatchChange) {
    var normalizedSize = normalizeOptionText(size);
    if (!normalizedSize) return;

    document.querySelectorAll(stickySelectSelector).forEach(function(select) {
      var matchingOption = Array.prototype.find.call(select.options || [], function(option) {
        return normalizeOptionText(option.text) === normalizedSize || normalizeOptionText(option.value) === normalizedSize;
      });

      if (!matchingOption) return;

      var changed = select.value !== matchingOption.value;
      select.value = matchingOption.value;
      matchingOption.selected = true;

      if (shouldDispatchChange && changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function setMainSize(size) {
    var normalizedSize = normalizeOptionText(size);
    if (!normalizedSize) return false;

    var targetInput = getMainSizeInputs().find(function(input) {
      return normalizeOptionText(getInputLabel(input)) === normalizedSize;
    });

    if (!targetInput || targetInput.disabled) return false;
    if (targetInput.checked) return true;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  function getBackInStockLabel() {
    var lang = String(document.documentElement.lang || navigator.language || 'en').toLowerCase().split('-')[0];
    var labels = {
      it: 'Notificami quando è disponibile',
      fr: 'Prévenez-moi quand disponible',
      de: 'Benachrichtige mich, wenn verfügbar',
      es: 'Avísame cuando esté disponible',
      en: 'Notify me when back in stock'
    };

    return labels[lang] || labels.en;
  }

  function isBackInStockEmbedActive() {
    return Boolean(
      window.SkiSisesBackInStockOpen ||
      document.querySelector('#BackInStockProductJson, script[src*="back-in-stock-widget.js"]')
    );
  }

  function isElementVisible(element) {
    if (!element || element.hasAttribute('hidden')) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return Boolean(rect && rect.width > 0 && rect.height > 0);
  }

  function isStickyAtcVisible(stickyAtc) {
    if (!isElementVisible(stickyAtc)) return false;

    if (stickyAtc.classList && stickyAtc.classList.contains('zrx-sticky-atc-show')) {
      return true;
    }

    var rect = stickyAtc.getBoundingClientRect();
    return rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      Math.abs(window.innerHeight - rect.bottom) < 12;
  }

  function syncStickyAtcLayoutState() {
    var stickyAtc = document.querySelector('.zrx-sticky-atc-bar');
    document.documentElement.classList.toggle('sks-has-sticky-atc', isStickyAtcVisible(stickyAtc));
  }

  function getBackInStockProductData() {
    if (productDataCache) return productDataCache;

    var script = document.getElementById('BackInStockProductJson');
    if (!script) return null;

    try {
      productDataCache = JSON.parse(script.textContent || '{}');
      return productDataCache;
    } catch (error) {
      return null;
    }
  }

  function isVariantAvailable(variant) {
    if (!variant) return null;
    if (variant.available === true || variant.availableForSale === true) return true;
    if (variant.available === false || variant.availableForSale === false) return false;

    var quantity = Number(variant.inventoryQuantity || variant.inventory_quantity || variant.stockQuantity);
    return Number.isFinite(quantity) ? quantity > 0 : null;
  }

  function getVariantById(variantId) {
    var productData = getBackInStockProductData();
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    var id = String(variantId || '');
    if (!id) return null;

    return variants.find(function(variant) {
      return String(variant.id || '') === id;
    }) || null;
  }

  function getVariantIdFromPicker() {
    var script = document.querySelector('variant-picker script[data-variant], .variant-picker script[data-variant]');
    if (!script) return '';

    try {
      var variant = JSON.parse(script.textContent || '{}');
      return variant && variant.id ? String(variant.id) : '';
    } catch (error) {
      return '';
    }
  }

  function getVariantIdFromSelectedOptions() {
    var productData = getBackInStockProductData();
    var options = productData && Array.isArray(productData.options) ? productData.options : [];
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!options.length || !variants.length) return '';

    var picker = Array.prototype.find.call(document.querySelectorAll('variant-picker, .variant-picker'), function(element) {
      return !element.closest('.zrx-sticky-atc-bar');
    });
    if (!picker) return '';

    var selectedValues = [];
    picker.querySelectorAll('input[data-option-position]:checked').forEach(function(input) {
      var optionIndex = Number(input.getAttribute('data-option-position')) - 1;
      if (!Number.isInteger(optionIndex) || optionIndex < 0) return;
      selectedValues[optionIndex] = normalizeOptionText(getInputLabel(input));
    });

    if (selectedValues.filter(Boolean).length < options.length) return '';

    var variant = variants.find(function(candidate) {
      var selectedOptions = candidate.selectedOptions || {};
      return options.every(function(optionName, index) {
        var selectedValue = selectedValues[index];
        var optionValues = Object.keys(selectedOptions).map(function(key) {
          return selectedOptions[key];
        });
        var variantValue = normalizeOptionText(selectedOptions[optionName] || optionValues[index]);
        return selectedValue && variantValue && selectedValue === variantValue;
      });
    });

    return variant ? String(variant.id || '') : '';
  }

  function getSelectedVariant() {
    var selectedVariantId = getVariantIdFromSelectedOptions() ||
      getVariantIdFromPicker() ||
      new URL(window.location.href).searchParams.get('variant') ||
      '';

    var variant = getVariantById(selectedVariantId);
    if (variant) return variant;

    var selectedSize = normalizeOptionText(getMainSelectedSize());
    var productData = getBackInStockProductData();
    var variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    if (!selectedSize) return null;

    return variants.find(function(candidate) {
      var selectedOptions = candidate.selectedOptions || {};
      return Object.keys(selectedOptions).some(function(key) {
        return normalizeOptionText(selectedOptions[key]) === selectedSize;
      });
    }) || null;
  }

  function shouldShowBackInStockForSelectedVariant() {
    var variant = getSelectedVariant();
    var availability = isVariantAvailable(variant);

    if (availability === null) return true;
    return !availability;
  }

  function openBackInStockModal(event) {
    if (!isBackInStockEmbedActive()) return;
    if (!shouldShowBackInStockForSelectedVariant()) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    if (typeof window.SkiSisesBackInStockOpen === 'function') {
      window.SkiSisesBackInStockOpen();
      return;
    }

    document.dispatchEvent(new CustomEvent('back-in-stock:open', { bubbles: true }));

    var fallbackButton = document.querySelector('[data-back-in-stock-button-kind="main"], [data-back-in-stock-button-kind="main-legacy"], .restock-rocket-button');
    if (fallbackButton && (!event || fallbackButton !== event.currentTarget)) {
      fallbackButton.click();
    }
  }

  function prepareBackInStockStickyMessage(message) {
    if (!isBackInStockEmbedActive()) return;
    if (!message || message.dataset.sksBackInStockPrepared === 'true') return;
    message.dataset.sksBackInStockPrepared = 'true';
    message.dataset.backInStockButton = 'true';
    message.dataset.backInStockButtonKind = 'sticky-legacy';
    message.classList.add('bis-widget-button', 'bis-widget-button--legacy', 'bis-widget-button--sticky', 'bis-widget-button--zrx-sticky');
    message.setAttribute('role', 'button');
    message.setAttribute('tabindex', '0');
    message.textContent = getBackInStockLabel();

    message.addEventListener('click', openBackInStockModal, true);
    message.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openBackInStockModal(event);
      }
    }, true);
    message.addEventListener('mouseenter', function() {
      message.style.setProperty('background', '#4a4a4a', 'important');
    });
    message.addEventListener('mouseleave', function() {
      message.style.setProperty('background', '#202223', 'important');
    });
    message.addEventListener('focus', function() {
      message.style.setProperty('background', '#4a4a4a', 'important');
    });
    message.addEventListener('blur', function() {
      message.style.setProperty('background', '#202223', 'important');
    });
  }

  function patchStickyOutOfStockLayout() {
    if (!isBackInStockEmbedActive()) return;
    var shouldShowMessage = shouldShowBackInStockForSelectedVariant();

    document.querySelectorAll('.zrx-sticky-atc-bar .zrx-sticky-atc-oos-message').forEach(function(message) {
      prepareBackInStockStickyMessage(message);
      message.dataset.visible = shouldShowMessage ? 'true' : 'false';
      message.hidden = !shouldShowMessage;

      if (!shouldShowMessage) {
        message.setAttribute('aria-hidden', 'true');
        message.style.setProperty('display', 'none', 'important');
        return;
      }

      message.setAttribute('aria-hidden', 'false');
      message.style.setProperty('grid-area', 'action', 'important');
      message.style.setProperty('align-self', 'center', 'important');
      message.style.setProperty('justify-self', 'stretch', 'important');
      message.style.setProperty('display', 'inline-flex', 'important');
      message.style.setProperty('align-items', 'center', 'important');
      message.style.setProperty('justify-content', 'center', 'important');
      message.style.setProperty('background', message.matches(':hover, :focus-visible') ? '#4a4a4a' : '#202223', 'important');
      message.style.setProperty('color', '#ffffff', 'important');
      message.style.setProperty('cursor', 'pointer', 'important');
      message.style.setProperty('width', '100%', 'important');
      message.style.setProperty('min-width', '0', 'important');
      message.style.setProperty('min-height', window.matchMedia('(min-width: 700px)').matches ? '3.25rem' : '3rem', 'important');
      message.style.setProperty('margin', '0', 'important');
      message.style.setProperty('border', '0', 'important');
      message.style.setProperty('border-radius', '0', 'important');
      message.style.setProperty('box-sizing', 'border-box', 'important');
      message.style.setProperty('font-size', window.matchMedia('(min-width: 700px)').matches ? '1rem' : '0.95rem', 'important');
      message.style.setProperty('font-weight', '400', 'important');
      message.style.setProperty('letter-spacing', '0', 'important');
      message.style.setProperty('line-height', '1.2', 'important');
      message.style.setProperty('text-align', 'center', 'important');
    });
  }

  function hasStickyControls() {
    return Boolean(
      document.querySelector(stickySelectSelector + ', .zrx-sticky-atc-bar .zrx-sticky-atc-oos-message')
    );
  }

  function syncStickyFromMain() {
    if (syncingVariantPickers) return;
    syncStickyAtcLayoutState();
    if (!hasStickyControls()) return;

    syncingVariantPickers = true;
    setStickySelect(getMainSelectedSize(), true);
    patchStickyOutOfStockLayout();
    syncStickyAtcLayoutState();
    syncingVariantPickers = false;
  }

  function queueStickySync() {
    if (syncFrame !== null) return;

    syncFrame = window.requestAnimationFrame(function() {
      syncFrame = null;
      syncStickyFromMain();
    });
  }

  function queueStickyLayoutStateSync() {
    if (layoutStateFrame !== null) return;

    layoutStateFrame = window.requestAnimationFrame(function() {
      layoutStateFrame = null;
      syncStickyAtcLayoutState();
    });
  }

  function isRelevantMutation(mutation) {
    if (mutation.type === 'attributes') {
      var target = mutation.target;
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.matches('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons') ||
        target.closest('.zrx-sticky-atc-bar, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      );
    }

    return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
      if (!(node instanceof Element)) return false;

      return (
        node.matches &&
        node.matches('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      ) || (
        node.querySelector &&
        node.querySelector('.zrx-sticky-atc-bar, .zrx-sticky-atc-oos-message, variant-picker, .variant-picker, product-sticky-bar, buy-buttons')
      );
    });
  }

  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches(stickySelectSelector)) {
      if (syncingVariantPickers) return;

      syncingVariantPickers = true;
      setMainSize(target.options[target.selectedIndex] ? target.options[target.selectedIndex].text : target.value);
      syncingVariantPickers = false;
      queueStickySync();

      return;
    }

    if (target.matches('variant-picker input[data-option-position], .variant-picker input[data-option-position]') && !target.closest('.zrx-sticky-atc-bar')) {
      queueStickySync();
    }
  }, true);

  document.addEventListener('variant:change', queueStickySync, true);
  document.addEventListener('product:rerender', queueStickySync, true);
  document.addEventListener('DOMContentLoaded', applyCookieBannerClickFix);
  document.addEventListener('DOMContentLoaded', queueStickySync);
  observeCookieBannerClickFix();
  applyCookieBannerClickFix();
  window.addEventListener('resize', queueStickyLayoutStateSync);
  window.addEventListener('scroll', queueStickyLayoutStateSync, { passive: true });
  window.addEventListener('load', applyCookieBannerClickFix);
  window.addEventListener('load', queueStickySync);

  if (document.body && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(mutations) {
      if (mutations.some(isRelevantMutation)) {
        queueStickySync();
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  var attempts = 0;
  var startupSync = window.setInterval(function() {
    queueStickySync();
    attempts += 1;

    if (attempts >= 4) {
      window.clearInterval(startupSync);
    }
  }, 650);
}());
